export const environment = {
  production: true,
  version: require('../../package.json').version,
  apiBase: 'https://integration.poured.us/',
  loginUrl: 'https://integration.poured.us/login',
  whitelistedDomains: ['https://integration.poured.us/', 'http://integration.poured.us/', 'https://admin-integration.poured.us/'],
  GoogleApiKey: 'AIzaSyBqgEtJz9zFA8If-YXrvXBcVuxmoueAWUw',
  s3Bucket: 'api-attachments',
};



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/environments/environment.ts